// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-A":"A_cost-saving-A__dTZMB"};